export const currencyDecimals: Record<string, number> = {
  USD: 2,
  EUR: 2,
  GBP: 2,
  KWD: 3,
  JPY: 0,
}

export const getCurrencyMultiplier = (currency: string) => {
  const decimals = currencyDecimals[currency.toUpperCase()] ?? 2
  return 10 ** decimals
}

export const formatAmountForInput = (amount: number, currency: string) => {
  const multiplier = getCurrencyMultiplier(currency)
  return amount != null ? amount / multiplier : 0
}

export const convertInputToMinorUnits = (input: number, currency: string) => {
  const multiplier = getCurrencyMultiplier(currency)
  return Math.round(input * multiplier)
}

/**
 * Formats a number as currency using a 2-letter locale code.
 * @param amount - The numeric amount in currency minimal unit (eg. cents)
 * @param currency - The currency code, e.g. 'USD', 'EUR', 'UAH'
 * @param locale - 2-letter locale code, e.g. 'en', 'de', 'uk'
 * @returns Formatted currency string
 */
export function formatMoney(amountInCents: number, currency: string = 'USD', locale: string = 'en'): string {
  const multiplier = getCurrencyMultiplier(currency)
  const decimals = currencyDecimals[currency.toUpperCase()] ?? 2
  const fullLocale = locale.length === 2 ? `${locale}-${locale.toUpperCase()}` : locale

  const amount = amountInCents / multiplier

  return new Intl.NumberFormat(fullLocale, {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: decimals,
  }).format(amount)
}
